import { GoabSpacer } from "@abgov/react-components";
import { MapMarker } from "../MapViewer";
import { ErrorMessage } from "./ErrorMessage";
import { setTokenSourceMapRange } from "typescript";

export const Map = ({ 
    form, 
    getResourceValue, 
    mapReference, 
    mapPosition, 
    markerPosition, 
    setMarkerPosition, 
    disabled, 
    setGeocodingLoading, 
    geocodingLoading, 
    setMapInstance,
    setSelectedAddress
}) => (
    <>
        <h4>{getResourceValue({ key: "RESOURCES@form.map.description" })}</h4>
        <GoabSpacer vSpacing="m" />
        <div ref={mapReference}>
            <MapMarker
                form={form}
                mapPosition={mapPosition}
                markerPosition={markerPosition}
                setMarkerPosition={setMarkerPosition}
                disabled={disabled}
                setGeocodingLoading={setGeocodingLoading}
                setMapInstance={setMapInstance}
                setSelectedAddress={setSelectedAddress}
            />
        </div>
        {geocodingLoading && <div>Loading...</div>}
        <ErrorMessage 
            error={!form.values.mapLat && !form.values.mapLng && form.errors.mapLat ? form.errors.mapLat : null} 
            getResourceValue={getResourceValue} 
        />
    </>
);